import { ComponentType, PropsWithChildren } from "react";

export interface LabelProps extends PropsWithChildren {
	readonly required?: boolean;
}
export const LabelDecorator: ComponentType<LabelProps> = function Label({ required, children }) {
	return (
		<>
			{children}
			{required ? "*" : ""}
		</>
	);
};
